import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["fullWidth"],
  _excluded2 = ["inputOpen"];
var _templateObject, _templateObject2;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { GRAY } from "../../constants/colors/hex";

// eslint-disable-next-line no-underscore-dangle
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _DropdownContainer = styled(function (_ref) {
  var fullWidth = _ref.fullWidth,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: ", ";\n  flex-flow: column;\n\n  .MuiInputBase-adornedEnd {\n    svg {\n      transition: transform 400ms;\n      transform-style: preserve-3d;\n    }\n  }\n\n  * {\n    cursor: pointer;\n  }\n"])), function (props) {
  return props.fullWidth ? 'flex' : 'inline-flex';
});

// eslint-disable-next-line no-underscore-dangle
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _EndAdornment = styled(function (_ref2) {
  var inputOpen = _ref2.inputOpen,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("span", rest);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-left: 6px;\n  display: inline-flex;\n\n  svg {\n    transform: rotateX(", "deg);\n    * {\n      fill: ", ";\n    }\n  }\n"])), function (props) {
  return props.inputOpen ? 180 : 0;
}, GRAY[5]);